'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.clonedeep');

var _lodash2 = _interopRequireDefault(_lodash);

var _redux = require('redux');

var _utils = require('../utils');

var _auth = require('../actions/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = _utils.ls.getItem('auth') || {};

var authReducer = function authReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
    var action = arguments[1];

    switch (action.type) {
        case _auth.REQUEST_LOGIN:
            return _extends({}, state, {
                isFetching: true
            });
        case _auth.RECEIVE_LOGIN:
            return _extends({}, state, {
                mobile: action.mobile,
                token: action.token,
                isFetching: false,
                lastUpdated: action.received_at,
                error: { ok: true }
            });
        case _auth.FAILURE_LOGIN:
            return _extends({}, state, {
                isFetching: false
            });
        case _auth.REQUEST_LOGOUT:
            return {};
        default:
            return state;
    }
};

exports.default = authReducer;


//////////////////
// WEBPACK FOOTER
// ./src/js/reducers/auth.js
// module id = 889
// module chunks = 0